//export const EquipsServiceAddress = 'http://localhost:8181';
//export const WebSocketAddress = 'ws://localhost:8080';
//export const EquipsServiceAddress = 'https://mprom.ml';
//export const WebSocketAddress = 'wss://mprom.ml:8080';

export const EquipsServiceAddress = window.EquipsServiceAddress;
export const WebSocketAddress = window.WebSocketAddress;
export const ComplexTypeImages = window.ComplexTypeImages;
export const UseDarkTheme = window.UseDarkTheme;

export const SearchPeriod = 7;
export const UserRole = 'User'
export const AdminRole = 'Administrator';
export const DetTunerAdminRole = 'DetTunerAdministrator';
export const SEUserRole = 'SEUser';
export const Roles = [UserRole, SEUserRole, DetTunerAdminRole, AdminRole];

export const SummaryTabIndex = 0;
export const EquipsTabIndex = 1;
export const MapTabIndex = 2;
export const EventsTabIndex = 3;
// export const HistoryTabIndex = 4;
export const ControlTabIndex = 4;
export const AdminTabIndex = 5;
export const DetTunerTabIndex = 6;

// correspond to MainToolBar.js Tabs
export const MainTabPanelIndex = 0;
export const SummaryDBTabPanelIndex = 1;
export const SummaryHistoryTabPanelIndex = 2;
export const SummaryChatTabPanelIndex = 3;
export const SummaryLogsTabPanelIndex = 4;
export const SummarySendToFtpServerInfoTabPanelIndex = 5;
export const ControlDiagnosticTabPanelIndex = 6;
export const ControlLogTabPanelIndex = 7;
export const ControlAtlasPwdLogTabPanelIndex = 8;
export const DetTunerTabPanelIndex = 9;
export const BoardsTabPanelIndex = 10;
export const RegistryTabPanelIndex = 11;
export const ServiceTabPanelIndex = 12;

export const CommonChat = 'CommonChat';
export const ChatMessageType = 'Chat';

export const MoscowTimeZone = 3;